<template>
  <div>
    <app-title>
      Registrations
      <v-btn color="success" @click="$router.go(-1)">Back</v-btn>
    </app-title>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" label="Filter" single-line hide-details></v-text-field>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="registrations"
          class="elevation-1"
          item-key="extension"
          :search="search"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td v-for="(prop,propIndex) in headers" :key="propIndex" :class="'ma-0'">
                <div v-if="prop.value == 'extension'" :class="'text-xs-' + prop.align">
                  <v-btn
                    flat
                    color="primary"
                    @click="$router.go('/link/registration/' +  props.item[prop.value])"
                  >{{props.item[prop.value]}}</v-btn>
                </div>
                <div v-else :class="'text-xs-' + prop.align">{{props.item[prop.value]}}</div>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-alert :value="true" color="error" icon="warning">There are no registrations</v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Extensions",
          align: "center",
          sortable: true,
          value: "extension"
        },

        {
          text: "Device Address",
          align: "center",
          sortable: true,
          value: "deviceAddress"
        },
        {
          text: "Device",
          align: "center",
          sortable: true,
          value: "device"
        },
        {
          text: "MAC",
          align: "center",
          sortable: true,
          value: "mac"
        },
        {
          text: "Duration",
          align: "center",
          sortable: true,
          value: "duration"
        }
      ],
      registrations: [
        {
          extension: 712,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink SIP-CP960",
          mac: "23:23:AB:35:23:11",
          duration: "2.6 hours"
        },
        {
          extension: 713,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink SIP-CP960",
          mac: "23:23:AB:35:23:11",
          duration: "12.6 hours"
        },
        {
          extension: 714,
          contact: "123.345.245.10:5060",
          deviceAddress: "udp:49.22.232.10:5060",
          device: "Snom SIP-CP413",
          mac: "23:23:AB:35:23:11",
          duration: "145.2 hours"
        },
        {
          extension: 354,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink LZI-2132",
          mac: "56:45:GD:34:34:11",
          duration: "0.2 hours"
        },
        {
          extension: 567,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink SIP-CP960",
          mac: "23:23:AB:35:23:11",
          duration: "2.6 hours"
        },
        {
          extension: 768,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink SIP-CP960",
          mac: "23:23:AB:35:23:11",
          duration: "12.6 hours"
        },
        {
          extension: 787,
          contact: "123.345.245.10:5060",
          deviceAddress: "udp:49.22.232.10:5060",
          device: "Snom SIP-CP413",
          mac: "23:23:AB:35:23:11",
          duration: "145.2 hours"
        },
        {
          extension: 222,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink LZI-2132",
          mac: "56:45:GD:34:34:11",
          duration: "0.2 hours"
        },
        {
          extension: 678,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink SIP-CP960",
          mac: "23:23:AB:35:23:11",
          duration: "2.6 hours"
        },
        {
          extension: 343,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink SIP-CP960",
          mac: "23:23:AB:35:23:11",
          duration: "12.6 hours"
        },
        {
          extension: 345,
          contact: "123.345.245.10:5060",
          deviceAddress: "udp:49.22.232.10:5060",
          device: "Snom SIP-CP413",
          mac: "23:23:AB:35:23:11",
          duration: "145.2 hours"
        },
        {
          extension: 346,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink LZI-2132",
          mac: "56:45:GD:34:34:11",
          duration: "0.2 hours"
        },
        {
          extension: 235,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink SIP-CP960",
          mac: "23:23:AB:35:23:11",
          duration: "2.6 hours"
        },
        {
          extension: 235,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink SIP-CP960",
          mac: "23:23:AB:35:23:11",
          duration: "12.6 hours"
        },
        {
          extension: 714,
          contact: "123.345.245.10:5060",
          deviceAddress: "udp:49.22.232.10:5060",
          device: "Snom SIP-CP413",
          mac: "23:23:AB:35:23:11",
          duration: "145.2 hours"
        },
        {
          extension: 342,
          contact: "49.255.232.10:5060",
          deviceAddress: "udp:49.255.232.10:5060",
          device: "Yealink LZI-2132",
          mac: "56:45:GD:34:34:11",
          duration: "0.2 hours"
        }
      ]
    };
  }
};
</script>

<style>
</style>
